const truncate = (value: string, maxLength: number): string => {
  const collapsed = value.replace(/\s+/g, ' ').trim();

  if (collapsed.length <= maxLength) {
    return collapsed;
  }

  return `${collapsed.slice(0, maxLength - 1).trimEnd()}…`;
};

export default truncate;
